import type { U3141ChildLotChain } from '../U3141Service';

/** Aligne la grille enfants sur un snapshot lotChainGraph après delete graphe (sous-arbre BL-0696). */
export function u3141SyncChildLotChainGridFromLotChainGraph(
  graph: U3141ChildLotChain[],
  currentRows: U3141ChildLotChain[],
): U3141ChildLotChain[] {
  const graphIds = new Set(graph.map((row) => row.id));
  const graphById = new Map(graph.map((row) => [row.id, row]));
  return currentRows
    .filter((row) => graphIds.has(row.id))
    .map((row) => graphById.get(row.id) ?? row);
}
